class Projects {

    constructor() {
        this.root = $('.js-projects-slider');
        this.slides = $('.js-projects-slider-item', this.root);
        this.pager = $('.js-projects-slider-pager', this.root);
        this.next = $('.js-projects-slider-next', this.root);
        this.prev = $('.js-projects-slider-prev', this.root);
        this.current = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0);
        this.animating = false;
        this.duration = 800;

        this.init();
    }

    init() {
        this.root.addClass('_dir-prev');
        this.current.next().addClass('_prev');

        this.slides.each((i,el) => {
            this.pager.append('<i' + (i == this.current.index() ? ' class="_active"' : '') + '>');
        });

        if (this.root.data('preRender')) {
            this.root.on('preRenderEnd', () => {
                this.current.addClass('_active');
                this.bind();
            });
        } else {
            this.current.addClass('_active');
            this.bind();
        }
    }

    bind() {
        this.root.addClass('_projects-slider-rendered');
        if (device.mobile() || device.tablet()) {
            this.root.hammer().on('swipeleft', (ev) => {
                this.next.click();
            });

            this.root.hammer().on('swiperight', (ev) => {
                this.prev.click();
            });
        }

        this.next.on('click', (e) => {
            this.slideTo(this.current.next().length ? this.current.next() : this.slides.eq(0));
        });

        this.prev.on('click', (e) => {
            this.slideTo(this.current.prev().length ? this.current.prev() : this.slides.eq(this.slides.length - 1));
        });

        this.pager.find('i').on('click', (e) => {
            this.slideTo(this.slides.eq($(e.currentTarget).index()));
        });
    }

    slideTo(slide) {
        if (this.animating || this.current[0] == slide[0]) return;
        this.animating = true;
        this.root.removeClass('_dir-prev _dir-next');
        this.slides.removeClass('_prev');
        if(this.current.index() - slide.index() == (this.slides.length - 1) || (this.current.index() - slide.index() != -(this.slides.length - 1) && this.current.index() < slide.index())) {
            this.root.addClass('_dir-next');
        } else {
            this.root.addClass('_dir-prev');
        }
        this.root[0].offsetHeight; // задержка
        this.current.removeClass('_active').addClass('_prev');
        this.current = slide.addClass('_active');
        this.pager.find('i').removeClass('_active').eq(this.current.index()).addClass('_active');
        setTimeout(() => {
            this.animating = false;
        }, this.duration);
    }
}

let projects = new Projects();

export default projects;